import Environment from '../../../Environment';
import { IFilter, buildUrl } from '../../BaseService';

export interface IPreparePassageUrl {
  filters?: IFilter[];
}

export function preparePassageUrl({ filters }: IPreparePassageUrl): string {
  return buildUrl({
    host: Environment.bibleService,
    resource: 'passage',
    filters,
  });
}
